import { create } from 'zustand';

interface EditCompanyPestModalState {
  isOpen: boolean;
  onManageEditClose: () => void;
  onManageEditMapOpen: () => void;
}

export const useEditCompanyPestModalStore = create<EditCompanyPestModalState>(set => ({
  isOpen: false,
  onManageEditClose: () => set({ isOpen: false }),
  onManageEditMapOpen: () => set({ isOpen: true }),
}));
